import React, { useState, useEffect } from 'react';
import api from '../../utils/api';
import { formatDate } from '../../utils/dateFormatter';
import './AdminTransactions.css';

const AdminTransactions = () => {
    const [transactions, setTransactions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [pagination, setPagination] = useState({
        page: 1,
        limit: 10,
        total: 0,
        pages: 1
    });

    useEffect(() => {
        fetchTransactions();
    }, [pagination.page]);

    const fetchTransactions = async () => {
        try {
            setLoading(true);
            const params = new URLSearchParams({
                page: pagination.page,
                limit: pagination.limit
            });
            const response = await api.get(`/admin/transactions?${params}`);
            if (response.data.success) {
                setTransactions(response.data.data.transactions);
                setPagination(response.data.data.pagination);
            }
        } catch (error) {
            console.error('Error fetching transactions:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="admin-transactions animate-fadeIn">
            <header className="page-header">
                <div className="header-info">
                    <h2>Transactions</h2>
                    <p>History of all payments and tag purchases</p>
                </div>
            </header>

            <div className="card">
                <div className="table-container">
                    <table className="admin-table">
                        <thead>
                            <tr>
                                <th>Transaction</th>
                                <th>Source / Customer</th>
                                <th>Details</th>
                                <th>Amount</th>
                                <th>Status</th>
                                <th>Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr><td colSpan="6" className="text-center">Loading transactions...</td></tr>
                            ) : transactions.length === 0 ? (
                                <tr>
                                    <td colSpan="6" className="text-center" style={{ padding: '4rem' }}>
                                        <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>💳</div>
                                        <h3 style={{ color: '#f8fafc' }}>No Transactions Found</h3>
                                        <p style={{ color: '#94a3b8' }}>History will appear here once payments are processed.</p>
                                    </td>
                                </tr>
                            ) : (
                                transactions.map(tx => {
                                    const isRestaurant = tx.table_id !== null;
                                    return (
                                        <tr key={tx.id}>
                                            <td>
                                                <div style={{ fontWeight: 800, color: '#f8fafc' }}>#{tx.id}</div>
                                                <div style={{ fontSize: '0.7rem', color: '#64748b', fontFamily: 'monospace' }}>{tx.payment_id || 'CASH/OFFLINE'}</div>
                                            </td>
                                            <td>
                                                {isRestaurant ? (
                                                    <div className="source-info">
                                                        <div style={{ color: '#10b981', fontWeight: 700, fontSize: '0.85rem' }}>🏪 {tx.franchise_business || tx.franchise_name || 'Restaurant'}</div>
                                                        <div style={{ fontSize: '0.75rem', color: '#64748b' }}>Cust: {tx.user_name || 'Guest'}</div>
                                                    </div>
                                                ) : (
                                                    <div className="source-info">
                                                        <div style={{ color: '#FF8C00', fontWeight: 700, fontSize: '0.85rem' }}>🏷️ Direct Purchase</div>
                                                        <div style={{ fontSize: '0.75rem', color: '#64748b' }}>{tx.user_name || 'Guest'}</div>
                                                    </div>
                                                )}
                                            </td>
                                            <td>
                                                {isRestaurant ? (
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                                        <span style={{ fontSize: '1.2rem' }}>🍽️</span>
                                                        <div>
                                                            <div style={{ fontSize: '0.85rem', fontWeight: 600 }}>Table {tx.table_number || 'N/A'}</div>
                                                            <div style={{ fontSize: '0.7rem', color: '#94a3b8' }}>Food Order</div>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                                        <span style={{ fontSize: '1.2rem' }}>{tx.type?.toLowerCase().includes('bike') ? '🏍️' : '🚗'}</span>
                                                        <div>
                                                            <div style={{ fontSize: '0.85rem', fontWeight: 600 }}>{tx.type || 'Vehicle Tag'}</div>
                                                            <div style={{ fontSize: '0.7rem', color: '#94a3b8' }}>NFC Tag Purchase</div>
                                                        </div>
                                                    </div>
                                                )}
                                            </td>
                                            <td><strong style={{ color: '#fff', fontSize: '1.1rem' }}>₹{tx.amount}</strong></td>
                                            <td>
                                                <span className={`badge ${tx.status?.toLowerCase()}`}>
                                                    {tx.status}
                                                </span>
                                            </td>
                                            <td>
                                                <div style={{ fontSize: '0.85rem' }}>{formatDate(tx.created_at)}</div>
                                            </td>
                                        </tr>
                                    );
                                })
                            )}
                        </tbody>
                    </table>
                </div>

                {pagination.pages > 1 && (
                    <div className="pagination">
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                            <label style={{ color: 'var(--text-secondary)', fontSize: '0.9rem' }}>Items:</label>
                            <select
                                value={pagination.limit}
                                onChange={(e) => setPagination({ ...pagination, limit: parseInt(e.target.value), page: 1 })}
                                style={{
                                    padding: '0.5rem',
                                    borderRadius: '0.5rem',
                                    background: 'var(--bg-input)',
                                    border: '1px solid var(--border-color)',
                                    color: 'var(--text-primary)',
                                    cursor: 'pointer'
                                }}
                            >
                                <option value="10">10</option>
                                <option value="20">20</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>
                        </div>
                        <button
                            disabled={pagination.page === 1}
                            onClick={() => setPagination({ ...pagination, page: pagination.page - 1 })}
                        >
                            Previous
                        </button>
                        <span>Page {pagination.page} of {pagination.pages}</span>
                        <button
                            disabled={pagination.page === pagination.pages}
                            onClick={() => setPagination({ ...pagination, page: pagination.page + 1 })}
                        >
                            Next
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default AdminTransactions;
